export const PROVINCES = [
  "Estuaire", "Haut-Ogooue", "Ogooue-Maritime", "Woleu-Ntem", "Ngounie",
  "Nyanga", "Ogooue-Ivindo", "Ogooue-Lolo", "Moyen-Ogooue",
];

export const VEH_TYPES = ["VOITURE", "BUS", "MINIBUS", "CAMION", "TAXI", "4X4", "MOTO"];

export const LIC_CATEGORIES = ["A", "B", "C", "D", "E"];

export const ORG_TYPES = [
  "MINISTERE", "ADMINISTRATION", "ETABLISSEMENT_PUBLIC", "ENTREPRISE",
  "ENTREPRISE_TRANSPORT", "SOCIETE_LOGISTIQUE", "OPERATEUR_PORTUAIRE",
  "SOCIETE_TAXI", "TRANSPORTEUR", "AUTRE",
];

export const PERSON_STATUTS = ["ACTIF", "SUSPENDU", "INACTIF"];
export const VEHICLE_STATUTS = ["EN_CIRCULATION", "IMMOBILISE", "REFORME"];
export const LICENSE_STATUTS = ["VALIDE", "EXPIRE", "SUSPENDU", "ANNULE"];

export const STATUT_LABELS = {
  ACTIF: "Actif",
  SUSPENDU: "Suspendu",
  INACTIF: "Inactif",
  EN_CIRCULATION: "En circulation",
  IMMOBILISE: "Immobilise",
  REFORME: "Reforme",
  VALIDE: "Valide",
  EXPIRE: "Expire",
  ANNULE: "Annule",
};

export const ORG_TYPE_LABELS = {
  MINISTERE: "Ministere",
  ADMINISTRATION: "Administration",
  ETABLISSEMENT_PUBLIC: "Etablissement public",
  ENTREPRISE: "Entreprise",
  ENTREPRISE_TRANSPORT: "Entreprise de transport",
  SOCIETE_LOGISTIQUE: "Societe logistique",
  OPERATEUR_PORTUAIRE: "Operateur portuaire",
  SOCIETE_TAXI: "Societe de taxi",
  TRANSPORTEUR: "Transporteur",
  AUTRE: "Autre",
};

export const ROLE_BADGE_COLORS = {
  SUPER_ADMINISTRATEUR: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  ADMINISTRATEUR: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  SUPERVISEUR: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  AGENT: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  CONSULTATION: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  AUDITEUR: "bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-300",
};
